requirePhoneNumber = false
window.addRequireFlagForPhoneNumber = function(){
  $("#phone-form_required").show()
  $("#phone-form_input").attr('custom-required',"")
  requirePhoneNumber=true;
}
window.removeRequireFlagForPhoneNumber = function(){
  $("#phone-form_required").hide()
  $("#phone-form_input").removeAttr('custom-required')
  requirePhoneNumber=false;
}
window.toggleRequireFlagForPhoneNumber = function(){
  if($('#requireFlag').is(':checked')){
    addRequireFlagForPhoneNumber()
  }else{
    removeRequireFlagForPhoneNumber()
  }
}
window.displayError = function(){
  $('.phone_input').addClass('input-error')
  $('.phone_input').addClass('errorText')
  $('p.phone_input').removeClass('hide')
}

window.hideError = function(){
  $('.phone_input').removeClass('input-error')
  $('.phone_input').removeClass('errorText')
  $('p.phone_input').addClass('hide')
}

checkSubmit = function(){
  // return true;
  var elemList = document.querySelectorAll('[custom-required=""]');
  var submitFlag = true;
  elemList.forEach(function(input){
    var regexObj = new RegExp(input.getAttribute('custom-matching'));
    var result = regexObj.test($.trim(input.value.replace(/[\n\r]/g,"")));
    if(result == false){
      $(input).addClass('input-error');
      var name = $(input).attr('input-name');
      $("#" + name + "-error-message").removeClass('hide');
      submitFlag = false
    } else {
      $(input).removeClass('input-error');
      var name = $(input).attr('input-name');
      $("#" + name + "-error-message").addClass('hide');
    }
  });

  // validate email
  submitFlag = $.fn.validateEmail() ? submitFlag : false;

  // check for checkbox if any is checked
  $.fn.validateRequiredFields();
  return submitFlag;
}

$.fn.validateEmail = function(){
  var validEmail = false;
  var elem = document.querySelector('input[input-name="email"]');

  if (elem != null && elem.value != "") {
      var env = "";
      if (document.domain.indexOf("test") > -1 || document.domain.indexOf("local") > -1) {
          env = ".test";
      } else if (document.domain.indexOf("stg") > -1) {
          env = ".stg";
      }

      var url= "https://api" + env + ".aperza.com/v2/product/validate/email/" + elem.value;

      $.ajax({
          type: "GET",
          url: url,
          async: false,
          timeout: 3000,
          dataType: 'json',
          success: function(msg){
              var name = $(elem).attr('input-name');
              if (msg.valid) {
                  $("#" + name + "-error-message").addClass('hide');
                  $(elem).removeClass('input-error');
              }
              else {
                  $("#" + name + "-error-message").removeClass('hide');
              }

              validEmail = msg.valid;
          },
          error: function(XMLHttpRequest, textStatus, errorThrown) {
          }
      });
  }

  return validEmail;
}

$.fn.validateRequiredFields = function(){
    var requiredForm = $("div.contactForm_kind[data-required='true']"); // get all form that are required

    requiredForm.each(function(index) {
        var checkedCheckboxes = $(this).find("input[type='checkbox']:checked")  // get all input elements in this
        var selectedRadio = $(this).find("input[type='radio']:checked")  // get any element that is selected
        var textValue = $(this).find("input[type='text']").val()  // get all input elements that has a value

        if (checkedCheckboxes !== undefined) {
            // it's as checkbox
            if (checkedCheckboxes.length > 0) {
                 $(this).find("p[id*='q-checkbox-error-']").addClass('hide');
            } else {
                 $(this).find("p[id*='q-checkbox-error-']").removeClass('hide');
            }
        }

        if (selectedRadio !== undefined) {
            // it's as radio
            if (selectedRadio.length > 0) {
                 $(this).find("p[id*='q-radio-error-']").addClass('hide');
            } else {
                $(this).find("p[id*='q-radio-error-']").removeClass('hide');
            }
        }

        if (textValue !== undefined) {
            //  is this text the others?
            if ($(this).find("input[type='text']").attr('id') === 'q-text-input-お問い合わせの種別（その他）') {

                if($("input[id='q-checkbox-input-その他のお問い合わせ']:checked").length === 0) {
                    // others checkbox is not checked - skip validation
                    $(this).find("p[id*='q-text-error-']").addClass('hide');    // put it back to no errors
                    $(this).find("input[type='text']").removeClass('input-error');
                    return true;
                };

                // otherwise proceed with validation, below
            }

            if ($(this).find("input[type='text']").attr('id') === 'mailAddress') {
              var url= host + "v/email/" + textValue;

		          $.ajax({
			          type: "GET",
			          url: url,
			          dataType: 'json',
			          success: function(msg){
                  $(this).find("p[id*='q-text-error-']").removeClass('hide');
                  $(this).find("input[type='text']").addClass('input-error');                  
                },
                error: function(XMLHttpRequest, textStatus, errorThrown) {
                  $(this).find("p[id*='q-text-error-']").removeClass('hide');
                  $(this).find("input[type='text']").addClass('input-error');                  
                }
              });
            }

            if (textValue.length > 0) {
                 $(this).find("p[id*='q-text-error-']").addClass('hide');
                 $(this).find("input[type='text']").removeClass('input-error');
            } else {
                 $(this).find("p[id*='q-text-error-']").removeClass('hide');
                 // for textBox wrap in error colors
                 $(this).find("input[type='text']").addClass('input-error');
            }
        }
    });
}

$.fn.moveOtherTextboxBesideOtherCheckbox = function(){
    var otherCheckbox = $("#q-other-input-その他のお問い合わせ");
    var otherInput = $("#q-text-span-お問い合わせの種別（その他）");
    var otherInputError = $("#q-text-error-お問い合わせの種別（その他）");

    if (otherCheckbox.length != 0) {
      // move input box beside the checkbox
      otherCheckbox.append(otherInput);
      otherCheckbox.append(otherInputError);

      // remove whole checkbox section
      $("#q-section-お問い合わせの種別（その他）").hide();
    }
}

$(document).ready(function() {
    $.fn.moveOtherTextboxBesideOtherCheckbox();
    window.toggleRequireFlagForPhoneNumber();
});